// app/javascript/controllers/smart_scenario_adjustment_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["variableKey", "units", "action", "value"]

  connect() {
    const parentController = this.element.closest("[data-controller='smart-scenario-adjustments']")
    this.variableRegistry = JSON.parse(parentController.dataset.smartScenarioAdjustmentsVariableRegistry)
    this.populateVariables()

    // Select current value if present
    if (this.variableKeyTarget.dataset.selectedKey) {
      this.variableKeyTarget.value = this.variableKeyTarget.dataset.selectedKey
    }

    this.updateUnits()

    // Optionally select a default
    if (this.unitsTarget.dataset.selectedUnits) {
      this.unitsTarget.value = this.unitsTarget.dataset.selectedUnits
    }
  }

  populateVariables() {
    this.variableKeyTarget.innerHTML = ""
    Object.entries(this.variableRegistry).forEach(([key, info]) => {
      const option = document.createElement("option")
      option.value = key
      option.textContent = info.label
      this.variableKeyTarget.appendChild(option)
    })
  }

  updateVariable(event) {
    this.updateUnits()
  }

  updateAction(event) {
    // Can tweak unit options based on action if needed
    // this.updateUnits()
  }

  updateUnits() {
    const key = this.variableKeyTarget.value
    const info = this.variableRegistry[key]

    // Clear existing options
    this.unitsTarget.innerHTML = ""

    if (!info || !info.units) return

    this.unitsTarget.selected = info.default_unit

    // info.units is expected to be an array: e.g. ["% points", "% proportionally"]
    info.units.forEach(unit => {
      const option = document.createElement("option")
      option.value = unit.key
      option.textContent = unit.label
      this.unitsTarget.appendChild(option)
    })

    // Select default unit from registry if available
    if (info.default_unit) {
      this.unitsTarget.value = info.default_unit
    } else if (this.unitsTarget.options.length > 0) {
      // fallback: select the first option
      this.unitsTarget.selectedIndex = 0
    }
  }
}
